import { ref } from "vue";
import { defineStore } from "pinia";
import type { IMyGarageViewModel } from "./IMyGarageViewModel";
import { MyGarageViewModel } from "..";
import { useMyGarageApi } from "./Api/MyGarageApi";
import { useUser } from "@domain/Security/User";

const useStore = defineStore( 'my-garage-view-model-store', () =>
{
    const instance = ref<IMyGarageViewModel>();
    return { instance };
} );

/**
 * Gets a new instance of the view model from the DTO returned from the API
 * @returns
 */
async function getViewModelInstance()
{
    const user = useUser();
    const api = useMyGarageApi();
    const dto = await api.getViewModelAsync( user?.appConsumerId!, user?.activeVehicle.vehicleId! );
    return new MyGarageViewModel( dto! );
}

/**
 * Force the view model to reload
 */
export async function reloadMyGarageViewModel()
{

    const user = useUser();
    const api = useMyGarageApi();
    const dto = await api.getViewModelAsync( user?.appConsumerId!, user?.activeVehicle.vehicleId! );

    const store = useStore();
    store.instance!.initialise( dto! );
    store.instance!.$updateKey += 1;
    return store.instance as IMyGarageViewModel;

}

/**
 * Gets the current view model instance from the store
 * @returns
 */
export async function useViewModelInstance( forceReload = false )
{
    const store = useStore();
    if( forceReload || store.instance == null || store.instance?.isDirty )
    {
        store.instance = await getViewModelInstance();
    }
    return store.instance as IMyGarageViewModel;
};

/**
 * Forces the view model to update/reinitialise via the API
 */
export async function updateViewModelInstance( appConsumerId : string, vehicleId : string )
{
    const store = useStore();
    const api = useMyGarageApi();
    const myGarageDto = await api.getViewModelAsync( appConsumerId, vehicleId );
    store.instance = new MyGarageViewModel( myGarageDto! );
    return store.instance as IMyGarageViewModel;
}
